import { createDtoBuilder, parseJsonDtoField } from '../../../../utils/dtoBuilder'

const DEFAULT_ALARM_ICON = { color: '#989898', icon: '', name: 'mdi mdi-alert-outline' }

export const buildAlarmRowDto = createDtoBuilder({
  transforms: {
    icon: (value) => value ? parseJsonDtoField(value, '') : '',
  },
})

export const buildAlarmDetailDto = createDtoBuilder({
  transforms: {
    icon: (value) => value ? parseJsonDtoField(value, DEFAULT_ALARM_ICON) : { ...DEFAULT_ALARM_ICON },
  },
})

export function buildAlarmRowsDto(list) {
  return Array.isArray(list) ? list.map(buildAlarmRowDto) : []
}
